export default{
    
  //agents
  GetAgents(state){
    return state.agents;
  },
  GetAgent(state){
    return state.agent;
  },
}